// extracted by mini-css-extract-plugin
export default {"UnstackSplash":"UnstackSplash_UnstackSplash__jA6eu","content":"UnstackSplash_content__FoasG","brand":"UnstackSplash_brand__6Zgth","spinner":"UnstackSplash_spinner__yCTV+"};